import { find } from "../utils/dom";

const Nav = () =>{
	const MenuNav = find('[js-nav-menu]');
	if(!MenuNav) return;

	window.addEventListener("scroll", () => {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    if(scrollTop > 200){
			MenuNav?.classList.add("is_scroll");
		}else{
			MenuNav?.classList.remove("is_scroll");
		}
});
}

export default Nav;